module.exports = __webpack_public_path__ + "img/1.74b9f89c.png";